"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordingClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class RecordingClient extends authenticated_client_1.AuthenticatedClient {
    getRecordings(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, payload = tslib_1.__rest(request, ["projectId"]);
            const queryString = this.getQueryString(payload);
            const url = `/v1/projects/${projectId}/recordings?${queryString}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getPagesFromRecording(project, sessionKey, goalId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${project}/recordings/${sessionKey}/pages?${goalId ? this.getQueryString({ goalId }) : ''}`;
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getEventsFromRecordedPageview(projectId, sessionKey, pageKey) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/recordings/${sessionKey}/pageviews/${pageKey}/events`;
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getSessionCount(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, payload = tslib_1.__rest(request, ["projectId"]);
            const queryString = this.getQueryString(payload);
            const url = `/v1/projects/${projectId}/recordings/count?${queryString}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getPlayingToken(projectId, sessionKey, pageNumber) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/recordings/playingToken?${this.getQueryString({ sessionKey, pageNumber })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getClicktalePlayingToken(projectId, sessionKey, pageNumber) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/recordings/playingToken?${this.getQueryString({
                sessionKey,
                pageNumber,
                type: 'clicktale',
            })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getClicktaleXStudioToken(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/recordings/xstudioToken`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
}
exports.RecordingClient = RecordingClient;
//# sourceMappingURL=recording.client.js.map